const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL ?? 'http://127.0.0.1:8787';

export type AdjustmentEvaluationPeriod = 'first_half' | 'second_half';

export type AdjustmentEvaluationEntry = {
  adjustmentItemId: number;
  count: number;
};

async function throwIfNotOk(response: Response) {
  if (response.ok) return;
  const payload = await response.json().catch(() => ({}));
  const message = typeof payload.message === 'string' ? payload.message : 'API request failed';
  throw new Error(message);
}

export async function fetchAdjustmentEvaluation(input: {
  userId: string;
  termNo: number;
  period: AdjustmentEvaluationPeriod;
}) {
  const params = new URLSearchParams({
    userId: input.userId,
    termNo: String(input.termNo),
    period: input.period,
  });
  const response = await fetch(`${apiBaseUrl}/api/adjustments?${params}`);
  await throwIfNotOk(response);
  return (await response.json()) as { entries: AdjustmentEvaluationEntry[] };
}

export async function fetchStoreAdjustmentEvaluation(input: {
  storeId: number;
  termNo: number;
  period: AdjustmentEvaluationPeriod;
}) {
  const params = new URLSearchParams({
    storeId: String(input.storeId),
    termNo: String(input.termNo),
    period: input.period,
  });
  const response = await fetch(`${apiBaseUrl}/api/admin/store-adjustments?${params}`);
  await throwIfNotOk(response);
  return (await response.json()) as { entries: AdjustmentEvaluationEntry[] };
}

export async function saveStoreAdjustmentEvaluation(input: {
  storeId: number;
  termNo: number;
  period: AdjustmentEvaluationPeriod;
  entries: AdjustmentEvaluationEntry[];
}) {
  const response = await fetch(`${apiBaseUrl}/api/admin/store-adjustments`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(input),
  });
  await throwIfNotOk(response);
}
